import { axiosInstance } from "./setup/axiosInstance";
import ENDPOINTS from "./setup/constants";

const getProfile = async (token) => {
	return axiosInstance.get(ENDPOINTS.accounts + "/my", {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => res.data)
		.catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};

const deleteProfile = async (token) => {
	return axiosInstance.delete(ENDPOINTS.accounts + "/my", {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			if (res.data.status !== 'OK') {
				return Promise.reject(res.data);
			}
			return res.data;
		})
		.catch((error) => {
			console.error('Delete Request Failed:', error.config);
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};

const profileApi = {
	getProfile: getProfile,
	deleteProfile: deleteProfile
};

export default profileApi;